import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "../styles.module.scss";
/*
 * Ingredient Card Component
 */
const IngredientCard = ({ amount, name, description, image, extraClassName }) => (_jsxs("div", { className: `${extraClassName || ""} ${styles.ingredient_wrapper}`, style: { backgroundImage: `url(${image})` }, children: [_jsx("span", { className: `${styles.ingredient_title} ${styles.ingredient_amount}`, children: amount }), _jsx("span", { className: styles.ingredient_title, children: name }), _jsx("span", { className: styles.ingredient_description, children: description })] }));
export default IngredientCard;
